export class Roles {
  static readonly INTERNAL_REQUESTER = 310700000;
  static readonly CLIENT_USER = 310700001;
  static readonly CLIENT_READER = 310700012;
  static readonly TECHNICAL_ENGINEER = 310700002;
  static readonly GOVERNANCE_MANAGER_EXTERNAL = 310700003;
  static readonly CUSTOMS_BROKER = 310700004;
  static readonly TECHNICAL_ENGINEER_MANAGER = 310700005;
  static readonly CBAM_ANALYST = 310700006;
  static readonly TRADE_ANALYST = 310700007;
  static readonly CLIENT_MANAGER = 310700008;
  static readonly INTERNAL_CBAM_ANALYST = 310700009;
  static readonly DISPUTE_MANAGER = 310700010;
  static readonly SUPPORT_ANALYST = 310700011;
}
